import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api-service';

import { notification } from 'antd';
import { WorkerInfo } from 'src/types/common.types';

type WorkerQueryParams = {
  includeWorkerPolicy: boolean;
};

const fetchWorkers = async (includeWorkerPolicy: boolean = false) => {
  const response = await ApiService.get<WorkerInfo[]>('/api/workers', {
    params: {
      includeWorkerPolicy,
    },
  });
  const data = response.data;
  if (response.status !== 200) {
    notification.error({
      message: 'Không thể lấy danh sách thợ',
    });
    return [];
  }
  return data;
};

const useWorkers = (queryParams?: WorkerQueryParams) => {
  const { includeWorkerPolicy: includeWorkerPolicy } = queryParams || { includeWorkerPolicy: false };
  return useQuery({
    queryKey: ['workers', includeWorkerPolicy],
    queryFn: () => fetchWorkers(includeWorkerPolicy),
    staleTime: 1000 * 60 * 5,
  });
};

export default useWorkers;
